import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useUnifiedCandidateSearch(searchTerm, enabled = false) {
  const api = useAxios();

  const { data, error, isLoading, isFetching } = useQuery({
    queryKey: ["unified-candidate-search", searchTerm],
    queryFn: async () => {
      const response = await api.get("/integrations/unified/candidates/search", {
        params: { query: searchTerm, limit: 25 },
      });
      return response?.data;
    },
    enabled: enabled && searchTerm.length >= 2,
    placeholderData: keepPreviousData,
  });

  const items = Array.isArray(data?.data) ? data.data : data?.data?.items || [];

  return {
    candidates: items,
    isLoading: isLoading || isFetching,
    error,
  };
}
